import updateOrderAction from "./updateOrderAction";
import getSurchargedCartAction from "./getSurchargedCartAction";

const setSelectedLocation = async (get, session, location) => {
    const currentLocId = get().order?.C_BPartner_Location_ID?.id;
    const selectedLocID = location.id;
    const returnVal = {};
    if(currentLocId !== selectedLocID) {
        await updateOrderAction(session, get, 'C_BPartner_Location_ID', selectedLocID);
        const refreshedOrder = await getSurchargedCartAction(session, false, get);
        for(const k of Object.keys(refreshedOrder)) {
            returnVal[k] = refreshedOrder[k];
        }
    }
    const currentInput = get().input || {};
    return {...returnVal, input: {...currentInput, locationID: selectedLocID, deliveryMethod: null, deliveryDate: null }}
}

export default setSelectedLocation;